// packages/shared-components/src/components/FormSection/FormSection.tsx

import { Children } from "react";
import { FormSectionProps } from "./types";
import styles from "./FormSection.module.css";

export function FormSection({
  title,
  description,
  rightContent, // ← 新增
  children,
  className = "",
  disabled = false,
}: FormSectionProps) {
  const hasChildren = Children.count(children) > 0;
  const hasHeaderOrDescription = Boolean(title || description);

  return (
    <section
      className={`${styles.formSection} ${className} ${disabled ? styles.disabled : ""}`}
    >
      {title && (
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
          {rightContent && (
            <div className={styles.rightContent}>{rightContent}</div>
          )}
        </div>
      )}
      {description && <p className={styles.description}>{description}</p>}
      {hasChildren && (
        <div
          className={`${styles.content} ${hasHeaderOrDescription ? styles.contentSpacing : ""}`}
        >
          {children}
        </div>
      )}
    </section>
  );
}
